module.exports = __webpack_public_path__ + "img/sm-2022-06-02_14-05-29.fdf26953.jpg";